import * as types from './action-types';
import api from '../utils/api';
import getAuth from '../utils/get-auth';

/**
 * Request backpack items for the current user.
 */
export const requestBackpackItems = () => {
  return (dispatch, getState) => {
    const auth = getAuth(getState());
    dispatch({
      type: types.BACKPACK_REQUEST_LIST,
      payload: api('/files', {
        headers: { 'Authorization': `JWT ${auth}` }
      })
    });
  }
};

/**
 * Request the deletion of a given item ID from the backpack.
 * @param {String} id The ID of the backpack item to delete.
 */
export const deleteBackpackItem = (id) => {
  return (dispatch, getState) => {
    const auth = getAuth(getState());
    dispatch({
      type: types.BACKPACK_DELETE_ITEM,
      payload: api(`/files/${id}`, {
        method: 'DELETE',
        headers: { 'Authorization': `JWT ${auth}` }
      }),
      meta: { id }
    });
  }
}



// WEBPACK FOOTER //
// ./src/actions/backpack-actions.js